import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { AiManagementState } from 'store/modules/ai_management_store/types';
import AiManagementFiltersPanel from 'components/molecules/ai_management_filters_panel';
import { Container } from './styles';

export type ViewMode = 'kanban' | 'lista' | 'calendario';

const VIEW_MODES: { key: ViewMode; label: string; icon: string }[] = [
  { key: 'kanban', label: 'Kanban', icon: 'view_kanban' },
  { key: 'lista', label: 'Lista', icon: 'view_list' },
  { key: 'calendario', label: 'Calendário', icon: 'calendar_today' },
];

interface AiManagementViewSwitcherProps {
  viewMode: ViewMode;
  onChange: (mode: ViewMode) => void;
}

const AiManagementViewSwitcher: React.FC<AiManagementViewSwitcherProps> = ({
  viewMode,
  onChange,
}) => {
  const { filters } = useSelector<ApplicationState, AiManagementState>(
    (state) => state.session.ai_management,
  );
  const [filtersOpen, setFiltersOpen] = useState(false);
  const filtersRef = useRef<HTMLDivElement>(null);

  const filtersCount =
    (filters.scope === 'mine' || filters.memberIds.length > 0 ? 1 : 0) +
    (filters.q.trim() ? 1 : 0) +
    (filters.deadlineFrom || filters.deadlineTo ? 1 : 0);

  useEffect(() => {
    if (!filtersOpen) return undefined;
    const handleClickOutside = (event: MouseEvent) => {
      if (filtersRef.current && !filtersRef.current.contains(event.target as Node)) {
        setFiltersOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [filtersOpen]);

  return (
    <Container className="d-flex justify-content-between align-items-center py-3">
      <div className="btn-group" role="group" aria-label="Modo de visualização">
        {VIEW_MODES.map((mode) => (
          <button
            key={mode.key}
            type="button"
            className={`btn btn-sm d-flex align-items-center ${
              viewMode === mode.key ? 'btn-dark' : 'btn-outline-secondary'
            }`}
            onClick={() => onChange(mode.key)}
          >
            <i className="material-icons mr-1">{mode.icon}</i>
            {mode.label}
          </button>
        ))}
      </div>

      <div className="position-relative" ref={filtersRef}>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary d-flex align-items-center"
          aria-expanded={filtersOpen}
          onClick={() => setFiltersOpen((open) => !open)}
        >
          <i className="material-icons mr-1">filter_list</i>
          Filtros
          {filtersCount ? <span className="badge badge-success ml-2">{filtersCount}</span> : null}
        </button>
        {filtersOpen && <AiManagementFiltersPanel onClose={() => setFiltersOpen(false)} />}
      </div>
    </Container>
  );
};

export default AiManagementViewSwitcher;
